import styled from 'styled-components';

export const Wrapper = styled.div`
    width: 100%;
    height: max-content;
    min-height: 100vh;
    background-color: #eff3f6;
    color: #242e3e;
    display: grid;
    grid-template:
        'appLogo appBar' 70px
        'sidebar main' 1fr
        'sidebar statusbar' max-content / 200px 1fr;
`;
